import React, { useState, useRef, useEffect } from "react";
import { useParams } from 'react-router-dom';
import MonacoEditor from "./Student/CodeEditor";
import CustomCKEditor from "./Student/TextEditor";
import AudioRecorder from "./Student/AudioRecorder";
import httpService from "services/httpService";
import * as constants from "Constants";
import Split from "@uiw/react-split";
import { FaRegThumbsUp, FaRegThumbsDown, FaPencilAlt, FaCheckCircle } from "react-icons/fa";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import { Tooltip } from "bootstrap";
import { Modal, Button, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import { marked } from "marked";
import DOMPurify from "dompurify";
import toWav from "audiobuffer-to-wav";
import { FaRedo, FaMicrophone } from "react-icons/fa"
import { IoSendSharp } from "react-icons/io5";


const CodeVaani = () => {
	const { courseId, labId, activityID } = useParams();

	// States
	const [currLabTitle, setCurrLabTitle] = useState("");
	const [currActivityTitle, setCurrActivityTitle] = useState("");
	const placeholderProblemStatement = "<h4>Paste the problem statement here<br>Or select activity from the dropdown to get it.</h4>";
	const [courseName, setCourseName] = useState("");
	const [labList, setLabList] = useState([]);
	const [activityList, setActivityList] = useState([]);
	const [selectedLab, setSelectedLab] = useState("");
	const [selectedActivity, setSelectedActivity] = useState("");
	const [labTitle, setLabTitle] = useState("");
	const [activityTitle, setActivityTitle] = useState("");
	const [problemStatement, setProblemStatement] = useState(placeholderProblemStatement);
	const [solutionCode, setSolutionCode] = useState("");
	const [taskId, setTaskId] = useState(null);
	const [asrTranscription, setAsrTranscription] = useState("");
	const [llmResponse, setLlmResponse] = useState("");
	const [editedQuery, setEditedQuery] = useState(false);

	const [parentCodevaaniId, setParentCodevaaaniId] = useState(null);
	const [codevaaniId, setCodevaaniId] = useState(null);
	const [transcribeTaskId, setTranscribeTaskId] = useState(null);
	const [inferenceTaskId, setInferenceTaskId] = useState(null);

	//Loading States for Transcription and Inference
	const [loadingTranscription, setLoadingTranscription] = useState(false);
	const [loadingInference, setLoadingInference] = useState(false);

	// Transcription language
	const [selectedTranscriptLang, setSelectedTranscriptLang] = useState("english");

	// for initial data load
	const [dataReady, setDataReady] = useState(false);
	const [initialDataLoad, setInitialDataLoad] = useState(true);

    // Whether audio sent or not
    const [audioSent, setAudioSent] = useState(false);

	// Feedback
	const [askTranscriptionFeedback, setAskTranscriptionFeedback] = useState(false);
	const [askResponseFeedback, setAskResponseFeedback] = useState(false);
  	const [transcriptionRated, setTranscriptionRated] = useState(false);
  	const [responseRated, setResponseRated] = useState(false);

	const [transcriptionLanguageList, setTranscriptionLanguageList] = useState([]);
	const [labActivityList, setLabActivityList] = useState([]);

	// Whether transcription changed or not
	const [isEditingTranscription, setIsEditingTranscription] = useState(false);
	const [editedTranscription, setEditedTranscription] = useState("");
		// For usage instructions popup
	const [showUsageInstructions, setShowUsageInstructions] = useState(false);

	const handleCloseInstructionPopUp = () => setShowUsageInstructions(false);
	const handleShowInstructionPopUp = () => setShowUsageInstructions(true);

	const [selectedTransriptFeedback, setSelectedTranscriptFeedback] = useState(null); // "like" | "dislike" | null
	const [selectedInferenceFeedback, setSelectedInferenceFeedback] = useState(null);

	const [selectedUserAction, setSelectedUserAction] = useState(null);
	const [codevaaniEnabled, setCodevaaniEnabled] = useState(null);

	const currentRequestRef = useRef(null);

	// --- Initial load ---
	useEffect(() => {
		const fetchInitialData = async () => {
			try {
				const courseRes = await httpService.get(
					`${constants.base_url}/courseware/api/course/${courseId}/get_full_course_detail/`
				);
				// console.log("Course", courseRes)
				if (courseRes?.data?.title) setCourseName(courseRes.data.title);
			} catch (err) {
				console.log(`Error getting the course details: ${err}`);
			}

			let isEnabled = false;
			try {
				const problemStatementRes = await httpService.get(`${constants.base_url}/evalpro/voicebot/problem_statement/${activityID}`);
				if (problemStatementRes?.data){
					// console.log("Problem Statement", problemStatementRes?.data?.data?.problem_statement);
					setProblemStatement(problemStatementRes?.data?.data?.problem_statement);
					setCurrLabTitle(problemStatementRes?.data?.data?.lab_title);
					setCurrActivityTitle(problemStatementRes?.data?.data?.activity_title);
					isEnabled = problemStatementRes?.data?.access_control_vars.enable_show_codevaani
					// console.log("isEnabled PS"+isEnabled);
					if(isEnabled!==null){
						setCodevaaniEnabled(isEnabled);
					}
					else{
						setCodevaaniEnabled(false);
					}
				}
			} catch (err) {
				console.error(`Error getting Activity Problem Statement: ${err}`);
				setCodevaaniEnabled(false);
			}

			try {
				const labActivityRes = await httpService.get(`${constants.base_url}/evalpro/voicebot/labs_activities_list/${courseId}`);
				if (labActivityRes?.data){
					// console.log("LA: ", JSON.stringify(labActivityRes?.data?.data?.labs));
					setLabActivityList(labActivityRes?.data?.data?.labs);
					const labs = labActivityRes?.data?.data?.labs.map(lab => ({
  						lab_title: lab.lab_title,
  						lab_id: lab.lab_id
						}));
					// console.log("Lab List", labs);
      				setLabList(labs);
					if(isEnabled){
						const labs_activities= labActivityRes?.data?.data?.labs;
						const exists = labs_activities.some(
							lab =>
							String(lab.lab_id) === labId &&
							lab.activities.some(activity => String(activity.activity_id) === activityID)
						);
						// console.log("ex: "+exists);
						if (exists) {
							setSelectedLab(labId);
							setSelectedActivity(activityID);
						}
						else{
							setSelectedLab("");
							setSelectedActivity("");
						}
					}
					else{
						setSelectedLab("");
						setSelectedActivity("");
					}
					setParentCodevaaaniId(null);
				}
			} catch (err) {
				console.log(`Error getting lab list: ${err}`);
			}

			try {
				const transcriptionLangRes = await httpService.get(`${constants.base_url}/evalpro/voicebot/supported_languages`);
				if (transcriptionLangRes?.data) {
					setTranscriptionLanguageList(transcriptionLangRes?.data?.data?.supported_languages);
					// console.log(transcriptionLangRes?.data?.data?.supported_languages);
				}
			} catch (err) {
				console.error(`Error getting Transcription Languages: ${err}`);
			}
		};
		fetchInitialData();
		const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
		[...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
	}, []);

	useEffect(() => {
		if(((problemStatement!==null && problemStatement!==placeholderProblemStatement) && transcriptionLanguageList.length > 0) || codevaaniEnabled===false){
				// console.log("enabled: "+ codevaaniEnabled);
				setDataReady(true);
				setInitialDataLoad(false);
				const lab_title = labList.find(item => item.lab_id == selectedLab)?.lab_title;
				const activity_title = activityList.find(item => item.activity_id == selectedActivity)?.activity_title;
				setLabTitle(!initialDataLoad ? lab_title : currLabTitle);
				setActivityTitle(!initialDataLoad ? activity_title : currActivityTitle);
				// console.log("activity_title: "+activity_title);
			}
	}, [problemStatement, transcriptionLanguageList, codevaaniEnabled]);

	// --- Lab change → Fetch activities ---
	useEffect(() => {
		const fetchActivities = async () => {
			if (!selectedLab) return;
			try {
				// filter labActivitiesList to get activities of selected lab
				// console.log("labActivityList: ", labActivityList);
				const lab = labActivityList.find(l => l.lab_id === Number(selectedLab));
				// console.log("Selected Lab: ", lab);
				if (lab) {
					// console.log("Fetched Activities", lab.activities);
					setActivityList(lab.activities);
					if(!initialDataLoad){
						setSelectedActivity("");
						setProblemStatement(placeholderProblemStatement);
					}
				} else {
					setActivityList([]);
				}

			} catch (err) {
				console.log(`Error getting activities: ${err}`);
			}
			// console.log("Selected Lab: ", selectedLab);
		};
		fetchActivities();
	}, [selectedLab]);

	// --- Activity change → Fetch problem statement ---
	useEffect(() => {
		const fetchProblemStatement = async () => {
			if(selectedActivity === "") return;
			try {
				let activity_id = selectedActivity;
				const problemStatementRes = await httpService.get(`${constants.base_url}/evalpro/voicebot/problem_statement/${activity_id}`);
				if (problemStatementRes?.data){
					// console.log("New Problem Statement", problemStatementRes?.data?.data?.problem_statement);
					setProblemStatement(problemStatementRes.data.data.problem_statement);
				}
			} catch (err) {
				console.error(`Error getting the problem statement: ${err}`);
			}
		};
		fetchProblemStatement();
	}, [selectedActivity]);

	const convertToWav = async (blob) => {
		const arrayBuffer = await blob.arrayBuffer();
		const audioCtx = new AudioContext();
		const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

		// Convert AudioBuffer → WAV ArrayBuffer
		const wavBuffer = toWav(audioBuffer);
		return new Blob([wavBuffer], { type: "audio/wav" });
	};

	// --- Send New CodeVaani Request ---
	const handleNewRequest = async (blob) => {
		// Check if all required fields are not NULL / Empty
		if (!solutionCode || solutionCode?.trim() === "") {
			displayGlobalMessage("Code is required for answering your Question", "error");
			return;
		}

		const normalize = (str = "") => str.replace(/\r?\n|\r/g, "").replace(/<br\s*\/?>/gi, "<br>").trim();

		if(!problemStatement || normalize(problemStatement)==normalize(placeholderProblemStatement))
		{
			displayGlobalMessage("Problem Statement is required for answering your Question", "error");
			return;
		}

		const requestId = Date.now();
    	currentRequestRef.current = requestId;

		setEditedQuery(false);
		setLoadingTranscription(true);
		setAskResponseFeedback(false);
		setAskTranscriptionFeedback(false);
		setAudioSent(false);
		setLoadingInference(true);
		setResponseRated(false);
		setEditedTranscription("");
		setTranscriptionRated(false);
		setTranscribeTaskId(null);
		setInferenceTaskId(null);
		setCodevaaniId(null);
		setSelectedTranscriptFeedback(null);
		setSelectedInferenceFeedback(null);
		setAsrTranscription("");
		setLlmResponse("");
		setSelectedUserAction(null);
		setIsEditingTranscription(false);

		const wavBlob = await convertToWav(blob);

		const formData = new FormData();
		// console.log("Edited Query: ", editedQuery);
		formData.append(
			"audio_file",
			wavBlob,
			`lab${selectedLab?.id}_activity${selectedActivity?.title}-${Date.now()}-${Math.random()}.wav`
		);
		formData.append("problem_statement", problemStatement);
		formData.append("code_solution", solutionCode);
		formData.append("language", selectedTranscriptLang);
		formData.append("edited_query", false);
		formData.append("parent_codevaani_id", parentCodevaaniId === null ? 0 : parentCodevaaniId);

		try {
			const res = await httpService.post(`${constants.base_url}/evalpro/voicebot/new_request/${activityID}`, formData);
			if (res?.data) {
				// console.log("New Request Response", res.data);
				const cvid = res?.data?.data?.codeVaani_id
				const task_id = res?.data?.data?.task_id;
				// console.log("Codevaani Id: ", cvid);
				// console.log("Edited Query1: ", editedQuery);
				setCodevaaniId(cvid);
				setTranscribeTaskId(res?.data?.data?.transcribe_task_id || null);
				setInferenceTaskId(res?.data?.data?.inference_task_id);
				setAudioSent(true);
				// console.log("Codevaani 0: ", codevaaniId);
				addTaskIdToCodevaani(cvid, false, task_id, requestId);
			}
		} catch (error) {
			console.log(`Error sending audio: ${error}`);
			setLoadingTranscription(false);
			setLoadingInference(false);
			setAskResponseFeedback(false);
			setAskTranscriptionFeedback(false);
			displayGlobalMessage(error?.response?.data?.detail || "Request Failure, Please Try Again.", "error");
		}
	};

	// --- Send Edited Transcription Request ---
	const sendRequestWithEditedTranscription = async () => {
		if (!solutionCode || solutionCode?.trim() === "") {
			displayGlobalMessage("Code is required for answering your Question", "error");
			return;
		}

		const normalize = (str = "") => str.replace(/\r?\n|\r/g, "").replace(/<br\s*\/?>/gi, "<br>").trim();

		if(!problemStatement || normalize(problemStatement)==normalize(placeholderProblemStatement))
		{
			displayGlobalMessage("Problem Statement is required for answering your Question", "error");
			return;
		}

		if(!editedTranscription)
		{
			displayGlobalMessage("Query is required for answering your Question", "error");
			return;
		}

		const requestId = Date.now();
    	currentRequestRef.current = requestId;

		setIsEditingTranscription(false);
		setAsrTranscription(editedTranscription);
		setAskResponseFeedback(false);
		setAskTranscriptionFeedback(false);
		setEditedQuery(true);
		setLoadingInference(true);
		setLoadingTranscription(false);
		setResponseRated(false);
		setTranscriptionRated(false);
		setTranscribeTaskId(null);
		setInferenceTaskId(null);
		setSelectedTranscriptFeedback(null);
		setSelectedInferenceFeedback(null);
		setLlmResponse("");
		setSelectedUserAction(null);
		
		const formData = new FormData();
		formData.append("problem_statement", problemStatement);
		formData.append("code_solution", solutionCode);
		formData.append("language", selectedTranscriptLang);
		formData.append("edited_query", true);
		formData.append("corrected_query", editedTranscription);
		formData.append("parent_codevaani_id", codevaaniId === null ? 0 : codevaaniId);
		// console.log("Here1 yees"+codevaaniId);
		try {
			setCodevaaniId(null);
			const res = await httpService.post(`${constants.base_url}/evalpro/voicebot/new_request/${activityID}`, formData);
			// console.log("Here yees"+ parentCodevaaniId);
			if (res?.data) {
				// console.log("Edited Query Request Response", res.data);
				const cvid = res?.data?.data?.codeVaani_id;
				const task_id = res?.data?.data?.task_id;
				// console.log("Codevaani Id: ", cvid);
				setCodevaaniId(cvid);
				setInferenceTaskId(res?.data?.data?.inference_task_id);
				addTaskIdToCodevaani(cvid, true, task_id, requestId);
			}
		} catch (error) {
			console.log(`Error sending audio: ${error}`);
			setLoadingTranscription(false);
			setLoadingInference(false);
			setAskResponseFeedback(false);
			setAskTranscriptionFeedback(false);
			displayGlobalMessage(error?.response?.data?.detail || "Request Failure, Please Try Again.", "error");
		}
	};

	// --- Add Task Id to Codevaani --- Update Task Ids in DB for Polling
	const addTaskIdToCodevaani = async (cvid, isEdited, taskId, requestId) => {
		try {
			console.log("Received Task ID: ", taskId);
			const formData = new FormData();
			formData.append("task_id", taskId);
			formData.append("program_id", activityID);
			const res = await httpService.put(`${constants.base_url}/evalpro/voicebot/update_task_ids/${cvid}`, formData);
			if (res?.data) {
				console.log("Add-Task-Id Response", res.data);
				const status = res?.data?.data?.status;
				if (status === "successful") {
					if(isEdited){
						pollingForInference(cvid, true, requestId);
					}
					else{
						pollingForTranscription(cvid, requestId);
					}
					displayGlobalMessage("CodeVaani Request added to Queue", "info");
				}
				else {
					console.log("Failed to add Task Id to Codevaani");
					setLoadingTranscription(false);
					setLoadingInference(false);
					setAskResponseFeedback(false);
					setAskTranscriptionFeedback(false);
					displayGlobalMessage("Request Failure, Please Try Again.", "error");
				}
			}
		} catch (error) {
			console.log(`Error adding Task Id to Codevaani: ${error}`);
			setLoadingTranscription(false);
			setLoadingInference(false);
			setAskResponseFeedback(false);
			setAskTranscriptionFeedback(false);
			displayGlobalMessage(error?.response?.data?.detail || "Request Failure, Please Try Again.", "error");
		}
	};
			

	// --- Polling for Transcription---
	const pollingForTranscription = async (cvid, requestId) => {
		if (currentRequestRef.current !== requestId) return;
		setEditedQuery(false);
			try {
				// console.log("Got Id T");
				const res = await httpService.get(`${constants.base_url}/evalpro/voicebot/get_status/transcription/${cvid}`);
				if (res?.data) {
					// console.log("Transcription Status: ", res.data);
					const status = res?.data?.data?.status;
					if (status === "successful") {
						setLoadingTranscription(false);
						setAsrTranscription(res?.data?.data?.result?.corrected_query || "");
						setEditedTranscription(res?.data?.data?.result?.corrected_query || "");
						pollingForInference(cvid, false, requestId);
					}
					else if (status === "failed") {
						setLoadingTranscription(false);
						setLoadingInference(false);
						setAskResponseFeedback(false);
						setAskTranscriptionFeedback(false);
						setAsrTranscription("ERROR: Failed to get Response");
						setLlmResponse("ERROR: Failed to get Response");
					}
					else {
						setTimeout(() =>
          					pollingForTranscription(cvid, requestId), 2000);
					}
				}
			} catch (error) {
				console.log(`Error getting Transcription Response: ${error}`);
				setLoadingTranscription(false);
				setLoadingInference(false);
				setAskResponseFeedback(false);
				setAskTranscriptionFeedback(false);
				setAsrTranscription("ERROR: Failed to get Response");
				setLlmResponse("ERROR: Failed to get Response");
				displayGlobalMessage(error?.response?.data?.detail || "Error Encountered while fetching Response", "error");
			}
	};

	// --- Polling for Inference---
	const pollingForInference = async (cvid, isEdited, requestId) => {
		if (currentRequestRef.current !== requestId) return;
		// console.log("Inside I");
			try {
				const res = await httpService.get(`${constants.base_url}/evalpro/voicebot/get_status/inference/${cvid}`);
				if (res?.data) {
					// console.log("Inference Status: ", res.data);
					// console.log("Edited Query PI: "+ isEdited);
					const status = res?.data?.data?.status;
					if (status === "successful") {
						setLoadingInference(false);
						setLlmResponse(res?.data?.data?.result?.codevaani_response || "");
						if(!isEdited)
						{
							setAskTranscriptionFeedback(true);
						}
						else{
							setAskTranscriptionFeedback(false);
						}
						setAskResponseFeedback(true);
					}
					else if (status === "failed") {
						setLoadingInference(false);
						setAskResponseFeedback(false);
						setAskTranscriptionFeedback(false);
						setLlmResponse("ERROR: Failed to get Response");
					}
					else {
						setTimeout(() =>
          					pollingForInference(cvid, isEdited, requestId), 2000);
					}
				}
			} catch (error) {
				console.log(`Error getting Inference Response: ${error}`);
				setLoadingInference(false);
				setAskResponseFeedback(false);
				setAskTranscriptionFeedback(false);
				displayGlobalMessage(error?.response?.data?.detail || "Error Encountered while fetching Response", "error");
			}
	};

	const saveFeedbackToDB = async(choice, action) => {
		if(codevaaniId){
			const formData = new FormData();
			formData.append(action, choice);
			formData.append("program_id", activityID);
			try {
				const res = await httpService.put(`${constants.base_url}/evalpro/voicebot/capture_response/${codevaaniId}`, formData);
				if (res?.data) {
					// console.log("SaveFeedback Status: ", res.data);
					const status = res?.data?.data?.status;
					if (status === "successful") {
						displayGlobalMessage("Feedback Saved", "info");
					}
				}
			} catch (error) {
				console.log(`Error getting Capture Feedback Response: ${error}`);
				displayGlobalMessage(error?.response?.data?.detail || "Error Encountered while fetching Response", "error");
			}
		}
	};

	const handleTranscriptionFeedback = async (choice) => {
		let feedback = null;
		setSelectedUserAction(null);
		if(selectedTransriptFeedback !== choice){
			feedback = choice;
		}
		setSelectedTranscriptFeedback(feedback);
		if(feedback!==null)
		{
			setTranscriptionRated(true);
			let transcription_correct = null;
			if(choice==="like"){
				transcription_correct = true;
			} else if(choice==="dislike"){
				transcription_correct = false;
				setParentCodevaaaniId(codevaaniId);
			}
			// console.log("TrFeed", transcription_correct);

			if(transcription_correct!==null)
			{
				saveFeedbackToDB(transcription_correct, "transcription_correct");
			}
		}
		else{
			setTranscriptionRated(false);
		}
	};

	const handleResponseFeedback = async (choice) => {
		let feedback = null;
		if(selectedInferenceFeedback !== choice){
			feedback = choice;
		}
		setSelectedInferenceFeedback(feedback);
		if(feedback!==null){
			setResponseRated(true);
			let response_helpful = null;
			if(choice==="like"){
				response_helpful = true;
			} else if(choice==="dislike"){
				response_helpful = false;
			}
			// console.log("InfFeed", response_helpful);
			
			if(response_helpful!==null)
			{
				saveFeedbackToDB(response_helpful, "response_helpful");
			}
		}
	};

	const handleUserAction = async (action) => {
		setSelectedUserAction(action);
		setParentCodevaaaniId(codevaaniId);

		if(codevaaniId){
			const formData = new FormData();
			formData.append("action", action);
			formData.append("program_id", activityID);
			try {
				const res = await httpService.put(`${constants.base_url}/evalpro/voicebot/response_actions/${codevaaniId}`, formData);
				if (res?.data) {
					// console.log("Save ResponseAction Status: ", res.data);
					const status = res?.data?.data?.status;
					// console.log("status of recording user action: ", status);
				}
			} catch (error) {
				console.log(`Error getting Capture Feedback Response: ${error}`);
			}
		}

	};

	const handleSelectedActivity = async (value) => {
		setSelectedActivity(value);
		setParentCodevaaaniId(null);
	};

	// --- UI ---
	if (!dataReady) {
		return (
			<div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden"></span>
				</div>
			</div>
		);
	}

	if(codevaaniEnabled===false)
	{
		return (
			<div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
				You are not Authorized to access CodeVaani
			</div>
		);
	}
	else
	{
	return (
		<div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
			<Breadcrumb>
				<Breadcrumb.Item href="#">
				  <Link to={`/courseware/course/${courseId}/content/labs`}>Labs</Link>
				</Breadcrumb.Item>
				<Breadcrumb.Item href="#">
				  <Link to={`/courseware/course/${courseId}/content/labs/${labId}/`}>
					{labTitle}
				  </Link>
				</Breadcrumb.Item>
				<Breadcrumb.Item active>
				<Link to={`/courseware/course/${courseId}/content/labs/${labId}/programming/${activityID}`}>
				  {activityTitle}
				  </Link>
				  </Breadcrumb.Item>
			  </Breadcrumb>
      		<div className="d-flex justify-content-between align-items-center p-3 text-dark mb-0">
				<h2 className="mb-0">{courseName}</h2>

				<div className="d-flex align-items-center">
					<span 
					style={{ fontFamily: "cursive", fontSize: "1.5rem" }}
					>
					CodeVaani
					</span>
					&emsp;
					<text style={{color: "darkblue", textTransform: "underline", cursor: "pointer"}} onClick={handleShowInstructionPopUp}>Usage / उपयोग</text>
				</div>
			</div>
			<div style={{ width: "100%", display: "flex", flexGrow: 1 }}>
			<Split
				direction= "horizontal"
				cursor= "col-resize"
				sizes={[50, 50]}
				minSize={0.2 * window.innerWidth}
				gutterSize={8}
				style={{ display: "flex", flexGrow: 1, width: "100%" }}
						
			>
				{/* Left Pane */}
				<div className="d-flex flex-column p-3 bg-light" style={{ width: "50%" }}>
				{/* Select Lab Dropdown */}
				<div className="row mb-3">
				<div className="col-md-6">
				<label htmlFor="selectLab" className="form-label mr-10">
				Lab: &emsp;&emsp;
				</label>
				<select
				id="selectLab"
				className="form-select"
				value={selectedLab}
				style={{ maxWidth: "200px" }}
				onChange={(e) => setSelectedLab(e.target.value)}
				>
				<option value="" disabled>
					-- Choose Lab --
				</option>
				{labList.map((lab, index) => (
					<option key={index} value={lab.lab_id}>
					{lab.lab_title}
					</option>
				))}
				</select>
				</div>

				{/* Select Activity Dropdown */}
				<div className="col-md-6">
				<label htmlFor="selectActivity" className="form-label mr-10">
				Activity: &ensp;
				</label>
				<select
				id="selectActivity"
				className="form-select"
				value={selectedActivity}
				style={{ maxWidth: "200px" }}
				onChange={(e) => handleSelectedActivity(e.target.value)}
				>
				<option value="" disabled>
					-- Choose Activity --
				</option>
				{activityList.map((activity, index) => (
					<option key={index} value={activity.activity_id}>
					{activity.activity_title}
					</option>
				))}
				</select>
				</div>
				</div>

				<h5 className="mb-2 mt-2">Problem Statement / प्रश्न <span className="text-red-600">*</span></h5>
				<div style={{ marginBottom: "1rem" }}>
				<CustomCKEditor
					value={problemStatement}
					onChange={(data) => setProblemStatement(data)}
				/>
				</div>

				<h5 className="mb-2 mt-3">Code <span className="text-red-600">*</span>
				&ensp;
					<span 
						className="ms-2 d-inline-flex justify-content-center align-items-center rounded-circle border"
						data-bs-toggle="tooltip" 
						data-bs-placement="top"
						title={`Type or paste your code here to ask your question / यहाँ अपना कोड टाइप या पेस्ट करें, जिसके बारे में आप प्रश्न पूछना चाहते हैं`}
						style={{
							width: "20px",
							height: "20px",
							fontSize: "0.8rem",
							cursor: "pointer"
						}}
					>
						i
					</span></h5>
				{/* Select Programming Language Dropdown */}
				<div style={{ flexGrow: 1, marginBottom: "0rem" }}>
				<MonacoEditor
					value={solutionCode}
					onChange={setSolutionCode}
					// language={programmingLanguage.toLowerCase()}
				/>
				</div>
				</div>

				{/* Right Pane */}
				<div className="d-flex flex-column p-3 bg-white" style={{ width: "50%" }}>
				<h5 className="mb-3">Record Your Query in Your Own Language / <br/> अपने code से जुड़ा सवाल रिकॉर्ड करें
				 &nbsp;<span className="text-red-600">*</span></h5>
				{/* Select Transcription Language Dropdown */}
				<div className="mb-3">
				<label htmlFor="selectTranscriptionLanguage" className="form-label">
				Select Language: &nbsp;
				</label>
				<span 
					className="ms-2 d-inline-flex justify-content-center align-items-center rounded-circle border"
					data-bs-toggle="tooltip" 
					data-bs-placement="top" 
					title={`Choose the language you’ll speak in / वह भाषा चुनें जिसमें आप बोलेंगे`}
					style={{
						width: "20px",
						height: "20px",
						fontSize: "0.8rem",
						cursor: "pointer"
					}}
				>
					i
				</span>
				&emsp;
				<select
					id="selectTranscriptionLanguage"
					className="form-select"
					value={selectedTranscriptLang}
					// onChange={(e) => {setSelectedTranscriptLang(e.target.value)}}
					onChange={(e) => {
						setSelectedTranscriptLang(e.target.value);
						e.target.size = 1;
						e.target.blur();
					}}
					onFocus={(e) => e.target.size = 5}
					onBlur={(e) => e.target.size = 1}
					style={{ overflowY: "auto" }}
				>
				{transcriptionLanguageList.map((lang, index) => (
					<option key={index} value={lang.val}>
					{lang.key}
					</option>
				))}
				</select>
				</div>
				
				<AudioRecorder
					onRecordingReady={({ blob, extradata }) => {
					handleNewRequest(blob);
				}}
				/>
				<div className="row align-items-baseline" style={{paddingLeft: "1rem"}}>
					<h5 className="mt-4 mb-2">What we heard / जो हमने सुना</h5>
					&emsp;
					<span 
						className="ms-2 d-inline-flex justify-content-center align-items-center rounded-circle border"
						data-bs-toggle="tooltip" 
						data-bs-placement="top" 
						title={`This is what we heard from your voice / यह वह है जो हमने आपकी आवाज़ से सुना`}
						style={{
							width: "20px",
							height: "20px",
							fontSize: "0.8rem",
							cursor: "pointer"
						}}
					>
						i
					</span>
				</div>
				<div
				className="border p-3 bg-light"
				style={{
				minHeight: "80px",
				maxHeight: "30vh",
				overflowY: "auto",
				borderRadius: "5px",
				}}
				>
					{/* Transcription display / edit area */}
					{loadingTranscription ? (
						<div className="d-flex justify-content-center align-items-center">
							<div className="spinner-border text-primary" role="status">
								<span className="visually-hidden"></span>
							</div>
						</div>
					) : (
					isEditingTranscription ? (
						<textarea
							id="editedTranscription"
							value={editedTranscription || asrTranscription}
							onChange={(e) => setEditedTranscription(e.target.value)}
							rows="5"
							className="form-control"
						/>
					) : (asrTranscription || "")
				)}

					{/* Edit Query */}
					{ isEditingTranscription ? (
						<div className="text-right">
							<button
							className="mt-2 px-2 py-1 bg-red-500 text-white rounded-lg border-none"
							onClick={() => setIsEditingTranscription(false)}
						>
							Cancel
						</button>
						&emsp;
						<button
							className="mt-2 px-2 py-1 bg-blue-500 text-white rounded-lg border-none"
							onClick={() => sendRequestWithEditedTranscription()}
						>
							Send
						</button>
						</div>
					) : (
						asrTranscription && transcriptionRated && (selectedTransriptFeedback==="dislike") && (<div className="text-right">
						<button
							className="btn btn-sm me-2"
							onClick={() => setIsEditingTranscription(true)}
						>
							<FaPencilAlt />
						</button>
						</div>)
					)
					}
				</div>
				
        {/* Transcription rating buttons */}
        {asrTranscription && askTranscriptionFeedback && audioSent && (
          <div className="d-flex justify-content-end mt-2">
          <button
            className="btn btn-sm me-2"
            onClick={() => handleTranscriptionFeedback("like")}
          >
            <FaRegThumbsUp 
				size={20}
				className={`
					cursor-pointer transition-colors duration-200
					${selectedTransriptFeedback === "like" ? "text-blue-600" 
              : "text-black hover:text-blue-400"}
        			`}
			/>
          </button>
          <button
            className="btn btn-sm"
            onClick={() => handleTranscriptionFeedback("dislike")}
          >
            <FaRegThumbsDown 
				size={20}
				className={`
					cursor-pointer transition-colors duration-200
					${selectedTransriptFeedback === "dislike" ? "text-red-600"
              : "text-black hover:text-red-700"}
					`}
			/>
          </button>
          </div>
        )}

      {asrTranscription && transcriptionRated && (selectedTransriptFeedback==="dislike") && !selectedUserAction && (
        <div className="space-x-2">
			Would you like to &nbsp;
          <button
            onClick={() => handleUserAction("edit_query")}
            className="px-2 py-1 bg-blue-500 text-white rounded border-none"
          >
            Edit Query
          </button>
		   &nbsp; OR &nbsp;
          <button
            onClick={() => handleUserAction("re-record")}
            className="px-2 py-1 bg-blue-500 text-white rounded border-none"
          >
            Re-record Query
          </button>
        </div>
      )}

      {selectedUserAction === "edit_query" && (
        <p className="text-gray-700">1. Click on the <span className="inline-block transform scale-x-[-1]">✏️</span>
		&nbsp; icon from <big>`What we heard`</big> section <br/> 2. After editing, click on Send button </p>
      )}

      {selectedUserAction === "re-record" && (
        <p className="text-gray-700">Click on &nbsp;
		<span className="inline-block transform px-2 py-1 rounded bg-blue-500 text-white rotate-90">↻</span>
		&nbsp; icon from <big>`Record your Question`</big> section </p>
      )}

	<div className="row align-items-baseline" style={{paddingLeft: "1rem"}}>
        <h5 className="mt-4 mb-2">CodeVaani Response / CodeVaani का जवाब</h5>
					&emsp;
					<span 
						className="ms-2 d-inline-flex justify-content-center align-items-center rounded-circle border"
						data-bs-toggle="tooltip" 
						data-bs-placement="top" 
						title={`Here’s the answer to your question / यहाँ आप अपने प्रश्न का उत्तर पाएँगे`}
						style={{
							width: "20px",
							height: "20px",
							fontSize: "0.8rem",
							cursor: "pointer"
						}}
					>
						i
					</span>
					</div>
				<div
				className="border p-3 bg-light"
				style={{
				minHeight: "80px",
				maxHeight: "30vh",
				overflowY: "auto",
				borderRadius: "5px",
				}}
				>
          {loadingInference ? (
						<div className="d-flex justify-content-center align-items-center">
							<div className="spinner-border text-primary" role="status">
								<span className="visually-hidden"></span>
							</div>
						</div>
					) : (
			<div
			dangerouslySetInnerHTML={{
				__html: DOMPurify.sanitize(marked.parse(llmResponse || "")),
			}}
			/>
		  )}
        </div>

        {/* llmResponse rating buttons */}
        {llmResponse && askResponseFeedback && audioSent && (
          <div className="d-flex justify-content-end mt-2">
          <button
            className="btn btn-sm me-2"
            onClick={() => handleResponseFeedback("like")}
          >
            <FaRegThumbsUp 
				size={20}
				className={`
					cursor-pointer transition-colors duration-200
					${selectedInferenceFeedback === "like" ? "text-blue-600" 
              : "text-black hover:text-blue-400"}
        			`}
			/>
          </button>
          <button
            className="btn btn-sm"
            onClick={() => handleResponseFeedback("dislike")}
          >
            <FaRegThumbsDown 
				size={20}
				className={`
					cursor-pointer transition-colors duration-200
					${selectedInferenceFeedback === "dislike" ? "text-red-600"
              : "text-black hover:text-red-700"}
					`}
			/>
          </button>
          </div>
        )}
        {/* {llmResponse && responseRated && askResponseFeedback(
          <p className="text-success text-end mt-2">llmResponse rated!</p>
        )} */}
			<div style={{display: "grid", justifyContent: "center", alignItems: "center",  marginTop: "15px"}}>
				<text style={{color: "dark gray"}}>This response is AI-generated and may be wrong. Please verify information independently.</text>
			</div>
        </div>
      </Split>
			</div>

			{/* Usage Instructions Modal */}
			<Modal show={showUsageInstructions} onHide={handleCloseInstructionPopUp} centered size="lg">
				<Modal.Header closeButton>
				<Modal.Title>Usage Instructions</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				<ol>
					<li>
					The problem statement is already filled in from the activity you came from.  
					<br />You can edit it or pick another activity from the dropdown if you’d like.
					</li>
					<li>
					In the code editor, type your own solution code — or paste the solution your instructor provided.
					</li>
					<li>
					Click the <FaMicrophone /> button and record your question by speaking.  
					<br />Once done, stop the recording and click on <b><IoSendSharp /></b>
					</li>
					<li>
					If you made a mistake while speaking, no worries — just re-record your question by clicking on <FaRedo />
					</li>
					<li>
					After sending, wait for:
					<ul>
						<li>Your voice to be transcribed</li>
						<li>A response to your question</li>
					</ul>
					</li>
					<li>
					You can (and we’d really appreciate it!) rate both the transcription and the response using the 👍 or 👎 buttons.  
					<br />If the transcription isn’t accurate → please downvote and edit it. <br /> We’ll then provide an updated response.
					</li>
				</ol>

				<p className="mt-3 text-danger">
					⚠️ <b>Word of caution:</b> Since the response is generated by AI, always cross-verify it independently before using it.
				</p>
				<p>That’s it! <br/> Thank you, and happy learning...</p>
				</Modal.Body>
				<Modal.Footer>
				<Button variant="secondary" onClick={handleCloseInstructionPopUp}>
					Close
				</Button>
				</Modal.Footer>
			</Modal>


		</div>
	);
	}
};

export default CodeVaani;
